import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { StoragePipeModule } from '@shared/utils';
import { ListLoadingIndicatorComponent } from '@shared/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { DeviceData } from '../../../stores/device.state';

export enum DeviceColumn {
  ORGANIZATION = 'organization',
  DEVICE = 'device',
  VERSION = 'version',
  NAME = 'name',
  SERIAL_NUMBER = 'serialNumber',
  PURCHASE_DATE = 'purchaseDate',
}

@Component({
  selector: 'ts-device-list',
  templateUrl: './device-list.component.html',
  styleUrls: ['./device-list.component.scss'],
  imports: [StoragePipeModule, ListLoadingIndicatorComponent, TranslateModule, MatTableModule, CommonModule],
})
export class DeviceListComponent implements OnChanges {
  @Input() items: DeviceData[] = [];
  @Input() loading = false;
  @Input() noDevices = false;
  @Input() clickableRows = true;
  @Input() visibleColumns: DeviceColumn[] = [];

  @Output() deviceClicked = new EventEmitter<DeviceData>();

  containerHeight: number | null = null;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading']) {
      if (this.loading) {
        // Capture current height when loading starts
        const element = this.elementRef.nativeElement as HTMLElement;
        this.containerHeight = element.offsetHeight;
      } else {
        // Release height when loading completes
        this.containerHeight = null;
      }
    }
  }
}
